











 










const node = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "requestId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAcceptRequestToJoinDomainMutation_success",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "requestId",
              "variableName": "requestId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "ReviewRequestToJoinOrgModal_viewer"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AcceptRequestToJoinDomainSuccess",
  "abstractKey": null
};

(node ).hash = "77386a235780e7cdb5dd84e8b67b04d5";

export default node;
